/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */
export const setInteractionType = <T>(value: T) => value;
